/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_H1Inputs */

const en_to_csv_h1 = /** @type {(inputs: To_Csv_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to CSV Converter`)
};

const ko_to_csv_h1 = /** @type {(inputs: To_Csv_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → CSV 변환기`)
};

const ja_to_csv_h1 = /** @type {(inputs: To_Csv_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → CSV変換ツール`)
};

/**
* | output |
* | --- |
* | "JSON to CSV Converter" |
*
* @param {To_Csv_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_h1 = /** @type {((inputs?: To_Csv_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_h1(inputs)
	if (locale === "ko") return ko_to_csv_h1(inputs)
	return ja_to_csv_h1(inputs)
});